import CrudModule from "@/components/CrudModule";
import { BookHeart } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export default function Stories() {
    return (
        <CrudModule
            testid="stories-page"
            eyebrow="Stories & Heritage"
            title="The intangible legacy — preserved."
            subtitle="Memories, lessons, family folklore and the small moments your descendants will treasure. Capture them while you can."
            endpoint="/stories"
            emptyIcon={BookHeart}
            emptyTitle="No stories yet"
            emptyBody="Begin with one memory — your wedding day, a grandparent's lesson, a family recipe, a lockdown observation. The vault holds them, generation after generation."
            fields={[
                { key: "title", label: "Title", required: true, placeholder: "The day Baba taught me to ride…" },
                { key: "period", label: "Life period", type: "select", defaultValue: "youth",
                  options: [
                    { value: "childhood", label: "Childhood" },
                    { value: "youth", label: "Youth" },
                    { value: "marriage", label: "Marriage" },
                    { value: "parenthood", label: "Parenthood" },
                    { value: "career", label: "Career" },
                    { value: "elder", label: "Elder years" },
                    { value: "other", label: "Other" },
                  ] },
                { key: "related_person", label: "About / for whom", placeholder: "Father, daughter, late grandmother…" },
                { key: "location", label: "Location", placeholder: "Lucknow, our flat in Bandra…" },
                { key: "event_date", label: "When did it happen", type: "date" },
                { key: "body", label: "The story", type: "textarea", required: true,
                  placeholder: "Tell it the way you'd tell it to a grandchild — small details, the smells, the words spoken." },
                { key: "tags", label: "Tags (comma separated)",
                  placeholder: "wedding, partition, recipe, lesson" },
            ]}
            columns={[
                { key: "title", label: "Title" },
                { key: "period", label: "Period",
                  render: (r) => <Badge variant="outline" className="capitalize">{r.period || "—"}</Badge> },
                { key: "related_person", label: "About" },
                { key: "event_date", label: "When", render: (r) => r.event_date || "—" },
                { key: "tags", label: "Tags",
                  render: (r) => Array.isArray(r.tags) && r.tags.length
                    ? <span className="text-xs">{r.tags.slice(0,3).join(" · ")}</span>
                    : "—" },
            ]}
        />
    );
}
